var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_471_71412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8574 18.2856H22.8574C22.2511 18.2856 21.6698 18.5265 21.2411 18.9551C20.8125 19.3838 20.5716 19.9651 20.5716 20.5714C20.5716 21.7838 20.09 22.9465 19.2327 23.8038C18.3754 24.6612 17.2126 25.1428 16.0002 25.1428C14.7878 25.1428 13.625 24.6612 12.7677 23.8038C11.9104 22.9465 11.4288 21.7838 11.4288 20.5714C11.4288 19.9651 11.188 19.3838 10.7593 18.9551C10.3307 18.5265 9.74928 18.2856 9.14307 18.2856H1.14307V28.5714C1.14307 29.1776 1.38388 29.7589 1.81254 30.1876C2.24119 30.6163 2.82257 30.8571 3.42878 30.8571H28.5716C29.1778 30.8571 29.7592 30.6163 30.1879 30.1876C30.6165 29.7589 30.8574 29.1776 30.8574 28.5714V18.2856Z",
    stroke: "#001184",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2861 9.14282L16.0004 14.8571L21.7147 9.14282",
    stroke: "#001184",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1.14282V14.8571",
    stroke: "#001184",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_471_71412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.f0ce8a1bf0138c41d25ecd55047aadab.svg";
export { ForwardRef as ReactComponent };